/** Formatting for the API dashboard. English, like the rest of the site. */

export function formatInt(n: number): string {
  return Math.round(n).toLocaleString("en-US");
}

/** "Oct 8, 2026" (UTC when `utc`, the viewer's zone otherwise). */
export function formatDate(iso: string | null | undefined, utc = false): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", ...(utc ? { timeZone: "UTC" } : {}) });
}

/** "just now", "5 min ago", "3 h ago", "2 days ago", else the date. */
export function formatAgo(iso: string | null | undefined, nowMs: number): string {
  if (!iso) return "never";
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return "—";
  const s = Math.max(0, Math.round((nowMs - t) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86_400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 30 * 86_400) {
    const d = Math.floor(s / 86_400);
    return `${d} day${d === 1 ? "" : "s"} ago`;
  }
  return formatDate(iso);
}

/** "in 5 h 12 min" / "in 3 days". */
export function formatIn(iso: string, nowMs: number): string {
  const s = Math.max(0, Math.round((Date.parse(iso) - nowMs) / 1000));
  if (s < 3600) return `in ${Math.max(1, Math.floor(s / 60))} min`;
  if (s < 86_400) {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return `in ${h} h${m ? ` ${m} min` : ""}`;
  }
  const d = Math.ceil(s / 86_400);
  return `in ${d} day${d === 1 ? "" : "s"}`;
}

/** "Oct 8" for a YYYY-MM-DD UTC day. */
export function formatDay(day: string): string {
  const d = new Date(`${day}T00:00:00Z`);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
}
